export type EnvKey = 'dev' | 'qa' | 'prod';

export interface EnvProfile {
  apiBaseUrl: string;
}

export const ENV_PROFILES: Record<EnvKey, EnvProfile> = {
  dev: { apiBaseUrl: 'https://api-demo.centricasoluciones.com' },
  qa: { apiBaseUrl: 'https://api-demo.centricasoluciones.com' },
  prod: { apiBaseUrl: 'https://api-demo.centricasoluciones.com' },
};

export function resolveEnvKey(): EnvKey {
  if (typeof window === 'undefined') return 'dev';
  const h = window.location.hostname;
  if (/-qa\./.test(h)) return 'qa';
  if (/-prod\./.test(h)) return 'prod';
  return 'dev';
}

export function getEnvProfile(): EnvProfile {
  return ENV_PROFILES[resolveEnvKey()];
}
